import { HoldsPlacedByInfo } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { FulfillmentHold } from "@redotech/redo-model/fulfillments/fulfillment-hold";
import { OMSUser } from "@redotech/redo-model/fulfillments/oms-user";
import { PlacedOnHoldSource } from "@redotech/redo-model/fulfillments/placed-on-hold-source";
import { ShopifyFulfillmentHoldDisplayNames } from "@redotech/redo-model/fulfillments/shopify-fulfillment-schemas";

function formatHoldDate(date: Date): string {
  return new Intl.DateTimeFormat("en-US", {
    month: "numeric",
    day: "numeric",
    year: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}

function getAttribution(
  holdsPlacedByInfo: HoldsPlacedByInfo | null | undefined,
  teamUsers: OMSUser[],
): string {
  if (!holdsPlacedByInfo?.source) {
    return "";
  }

  switch (holdsPlacedByInfo.source) {
    case PlacedOnHoldSource.USER_ACTION: {
      if (holdsPlacedByInfo.placedByUserId) {
        const userId = holdsPlacedByInfo.placedByUserId.toString();
        const user = teamUsers.find((u) => u._id === userId);
        if (user) {
          return ` by ${user.name}`;
        }
      }
      return " by a team member";
    }
    case PlacedOnHoldSource.AUTOMATION: {
      const automationName = holdsPlacedByInfo.placedByAutomationName;
      return automationName
        ? ` by automation ${automationName}`
        : " by automation";
    }
    case PlacedOnHoldSource.MARKETPLACE_SYNC: {
      return " by marketplace sync";
    }
    case PlacedOnHoldSource.ADDRESS_VERIFICATION_FAILURE: {
      return " by address verification";
    }
    default: {
      return "";
    }
  }
}

export function formatHoldNotes(
  holds: FulfillmentHold[] | null | undefined,
  holdsPlacedByInfo: HoldsPlacedByInfo | null | undefined,
  orderName: string,
  teamUsers: OMSUser[],
): string {
  if (!holds || holds.length === 0) {
    return "";
  }

  const attribution = getAttribution(holdsPlacedByInfo, teamUsers);

  return holds
    .map((hold) => {
      const datePrefix = hold.placedAt
        ? `${formatHoldDate(hold.placedAt)} `
        : "";
      const reasonDisplay =
        ShopifyFulfillmentHoldDisplayNames[hold.reason] ?? hold.reason;
      const noteSuffix = hold.reasonNotes ? `. Note: ${hold.reasonNotes}` : "";

      return `${datePrefix}${orderName} placed on hold${attribution} with hold reason ${reasonDisplay}${noteSuffix}.`;
    })
    .join("\n");
}
